import React from 'react'
import TextInput from '../../common/TextInput'
import MultiSelectDropdown from '../../dropdown/MultiSelectDropdown'
import ToggleSwitch from '../../common/ToggleSwitch'
import Table from '../../common/Table'

function RawMaterialTestEntryInputs(props) {
    return (
        <div className='raw-test-inner'>
            <div className='test-inner grid grid-cols-4 gap-2.5 pb-2.5 mb-2 border-b border-gray-200'>
                <div className='input-grp'>
                    <label>Ref No</label>
                    <TextInput
                        className="inputFocus"
                        type="text"
                        id="refNo"
                        name="refNo"
                        value={props.reportObject.refNo}
                        onChange={(event) => props.handleChange(event, "refNo", "report")}
                        disabled
                    />
                </div>
                <div className='input-grp'>
                    <label>Report No</label>
                    <TextInput
                        className={`inputFocus ${props.validState?.error?.reportNo ? "errorInput" : ""}`}
                        type="text"
                        id="reportNo"
                        name="reportNo"
                        value={props.reportObject.reportNo}
                        onChange={(event) => props.handleChange(event, "reportNo", "report")}
                    />
                </div>
                <div className='input-grp'>
                    <label>Report Date</label>
                    <TextInput
                        className={`inputFocus ${props.validState?.error?.reportDate ? "errorInput" : ""}`}
                        type="date"
                        id="reportDate"
                        name="reportDate"
                        value={props.reportObject.reportDate}
                        onChange={(event) => props.handleChange(event, "reportDate", "report")}
                    />
                </div>
                <div className='input-grp'>
                    <label>Analysis Date</label>
                    <TextInput
                        className={`inputFocus ${props.validState?.error?.analysisDate ? "errorInput" : ""}`}
                        type="date"
                        id="analysisDate"
                        name="analysisDate"
                        value={props.reportObject.analysisDate}
                        onChange={(event) => props.handleChange(event, "analysisDate", "report")}
                    />
                </div>
                <div className='input-grp'>
                    <label>Sample Name</label>
                    <TextInput
                        className="inputFocus"
                        type="text"
                        id="materialName"
                        name="materialName"
                        value={props.reportObject.materialName}
                        onChange={(event) => props.handleChange(event, "materialName", "report")}
                        disabled
                    />
                </div>
                <div className='input-grp'>
                    <label>Batch No</label>
                    <TextInput
                        className="inputFocus"
                        type="text"
                        id="batchNo"
                        name="batchNo"
                        value={props.reportObject.batchNo}
                        onChange={(event) => props.handleChange(event, "batchNo", "report")}
                        disabled
                    />
                </div>
                <div className='input-grp col-span-1'>
                    <label>Supplier</label>
                    <TextInput
                        className="inputFocus"
                        type="text"
                        id="partyName"
                        name="partyName"
                        value={props.reportObject.partyName}
                        onChange={(event) => props.handleChange(event, "partyName", "report")}
                        disabled
                    />
                </div>
                <div className='input-grp'>
                    <label>Sample Qty</label>
                    <TextInput
                        className="inputFocus"
                        type="number"
                        id="sampleQty"
                        name="sampleQty"
                        value={props.reportObject.sampleQty}
                        onChange={(event) => props.handleChange(event, "sampleQty", "report")}
                        disabled
                    />
                </div>
                <div className='input-grp'>
                    <label>{props.testEntryType === "FinishProducts" ? "Batch size" : "Purchase Qty"}</label>
                    <TextInput
                        className="inputFocus"
                        type="number"
                        id="purchaseQty"
                        name="purchaseQty"
                        value={props.reportObject.purchaseQty}
                        onChange={(event) => props.handleChange(event, "purchaseQty", "report")}
                        disabled
                    />
                </div>
                <div className='input-grp col-span-1'>
                    <label>Manufacturer</label>
                    <TextInput
                        className="inputFocus"
                        type="text"
                        id="mfgBy"
                        name="mfgBy"
                        value={props.reportObject.mfgBy}
                        onChange={(event) => props.handleChange(event, "mfgBy", "report")}
                        disabled
                    />
                </div>
                <div className='input-grp'>
                    <label>Analysist</label>
                    <TextInput
                        className="inputFocus"
                        type="text"
                        id="analyst"
                        name="analyst"
                        value={props.reportObject.analyst}
                        onChange={(event) => props.handleChange(event, "analyst", "report")}
                    />
                    {/* <MultiSelectDropdown
                        drpIdentity="analystId"
                        options={props.analystList}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        onChange={(selected) =>
                            props.setFilterParametersForItemName(selected, "analystId", "report")
                        }
                        allowSelectAll={false}
                        value={props.analystList.filter(
                            (party) => party.value === props.reportObject.analystId
                        )}
                    /> */}
                </div>
                <div className='input-grp'>
                    <label>Lab. Incharge</label>
                    <TextInput
                        className="inputFocus"
                        type="text"
                        id="labIncharge"
                        name="labIncharge"
                        value={props.reportObject.labIncharge}
                        onChange={(event) => props.handleChange(event, "labIncharge", "report")}
                    />
                    {/* <MultiSelectDropdown
                        drpIdentity="inchargeId"
                        options={props.inchargeList}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        onChange={(selected) =>
                            props.setFilterParametersForItemName(selected, "inchargeId", "report")
                        }
                        allowSelectAll={false}
                        value={props.inchargeList.filter(
                            (party) => party.value === props.reportObject.inchargeId
                        )}
                    /> */}
                </div>

                <div className='input-grp'>
                    <label>Publ. Lab. Name</label>
                    <TextInput
                        className="inputFocus"
                        type="text"
                        id="labName"
                        name="labName"
                        value={props.reportObject.labName}
                        onChange={(event) => props.handleChange(event, "labName", "report")}
                        disabled
                    />
                </div>
            </div>
            <span className="text-blue text-[18px] font-semibold">Test Details</span>
            <div className='test-table-inner grid grid-cols-4 gap-2.5 mb-2.5'>
                <div className='input-grp col-span-2'>
                    <label>Test Name</label>
                    <TextInput
                        className="inputFocus"
                        type="text"
                        id="testName"
                        name="testName"
                        value={props.testObject.testName}
                        onChange={(event) => props.handleChange(event, "testName", "test")}
                        disabled
                    />
                </div>
                <div className='input-grp col-span-2'>
                    <label>Result</label>
                    <TextInput
                        className="inputFocus"
                        type="text"
                        id="result"
                        name="result"
                        value={props.testObject.result}
                        onChange={(event) => props.handleChange(event, "result", "test")}
                    />
                </div>
                <div className='input-grp col-span-2'>
                    <label>Limit</label>
                    <TextInput
                        className="inputFocus"
                        type="text"
                        id="limit"
                        name="limit"
                        value={props.testObject.limit}
                        onChange={(event) => props.handleChange(event, "limit", "test")}
                        disabled
                    />
                </div>
                {
                    props.testObject.isEditing ?
                        <div className='btn-grp col-span-2'>
                            <button
                                className='search-btn h-fit mt-5'
                                onClick={props.updateTestResult}
                            >
                                Update
                            </button>
                            <button
                                className='cancel-btn h-fit mt-5'
                                onClick={props.clearTestObject}
                            >
                                Clear
                            </button>
                        </div>
                        : null
                }
            </div>
            <Table
                tableData={props.tableData}
                columns={props.columns}
                scrollHeight="calc(100dvh - 190px)"
            />
        </div>
    )
}

export default RawMaterialTestEntryInputs